import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/peeps-logo.png";

// Small peeps icon that returns to the "Your groups" home screen.
export function HomeButton({ size = 34, bg = "rgba(21,22,30,0.3)", testID = "home-peeps-button" }) {
  const navigate = useNavigate();
  return (
    <button
      data-testid={testID}
      onClick={() => navigate("/")}
      title="Home"
      aria-label="Home"
      className="shrink-0 rounded-full flex items-center justify-center transition-transform active:scale-90"
      style={{ width: size, height: size, background: bg }}
    >
      <img src={logo} alt="peeps" className="rounded-md" style={{ width: size - 8, height: size - 8 }} />
    </button>
  );
}
